/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StandardUser } from './StandardUser';
import {
    StandardUserFromJSON,
    StandardUserFromJSONTyped,
    StandardUserToJSON,
    StandardUserToJSONTyped,
} from './StandardUser';
import type { XpMultiplier } from './XpMultiplier';
import {
    XpMultiplierFromJSON,
    XpMultiplierFromJSONTyped,
    XpMultiplierToJSON,
    XpMultiplierToJSONTyped,
} from './XpMultiplier';
import type { CookieConsent } from './CookieConsent';
import {
    CookieConsentFromJSON,
    CookieConsentFromJSONTyped,
    CookieConsentToJSON,
    CookieConsentToJSONTyped,
} from './CookieConsent';
import type { AddressBook } from './AddressBook';
import {
    AddressBookFromJSON,
    AddressBookFromJSONTyped,
    AddressBookToJSON,
    AddressBookToJSONTyped,
} from './AddressBook';
import type { UserOrigin } from './UserOrigin';
import {
    UserOriginFromJSON,
    UserOriginFromJSONTyped,
    UserOriginToJSON,
    UserOriginToJSONTyped,
} from './UserOrigin';
import type { CheatFlagHistoryEntry } from './CheatFlagHistoryEntry';
import {
    CheatFlagHistoryEntryFromJSON,
    CheatFlagHistoryEntryFromJSONTyped,
    CheatFlagHistoryEntryToJSON,
    CheatFlagHistoryEntryToJSONTyped,
} from './CheatFlagHistoryEntry';
import type { SubscriptionTierStatus } from './SubscriptionTierStatus';
import {
    SubscriptionTierStatusFromJSON,
    SubscriptionTierStatusFromJSONTyped,
    SubscriptionTierStatusToJSON,
    SubscriptionTierStatusToJSONTyped,
} from './SubscriptionTierStatus';
import type { Asset } from './Asset';
import {
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
    AssetToJSONTyped,
} from './Asset';
import type { PhoneNumber } from './PhoneNumber';
import {
    PhoneNumberFromJSON,
    PhoneNumberFromJSONTyped,
    PhoneNumberToJSON,
    PhoneNumberToJSONTyped,
} from './PhoneNumber';
import type { DiscordInfo } from './DiscordInfo';
import {
    DiscordInfoFromJSON,
    DiscordInfoFromJSONTyped,
    DiscordInfoToJSON,
    DiscordInfoToJSONTyped,
} from './DiscordInfo';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';
import type { GamerTag } from './GamerTag';
import {
    GamerTagFromJSON,
    GamerTagFromJSONTyped,
    GamerTagToJSON,
    GamerTagToJSONTyped,
} from './GamerTag';

/**
 * 
 * @export
 * @interface MerchantUser
 */
export interface MerchantUser extends StandardUser {
    /**
     * 
     * @type {Array<string>}
     * @memberof MerchantUser
     */
    stripeAccountIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MerchantUser
     */
    latestMerchantAgreementId?: string;
}



/**
 * Check if a given object implements the MerchantUser interface.
 */
export function instanceOfMerchantUser(value: object): value is MerchantUser {
    return true;
}

export function MerchantUserFromJSON(json: any): MerchantUser {
    return MerchantUserFromJSONTyped(json, false);
}

export function MerchantUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): MerchantUser {
    if (json == null) {
        return json;
    }
    return {
        ...StandardUserFromJSONTyped(json, true),
        'stripeAccountIds': json['stripeAccountIds'] == null ? undefined : json['stripeAccountIds'],
        'latestMerchantAgreementId': json['latestMerchantAgreementId'] == null ? undefined : json['latestMerchantAgreementId'],
    };
}

export function MerchantUserToJSON(json: any): MerchantUser {
    return MerchantUserToJSONTyped(json, false);
}

export function MerchantUserToJSONTyped(value?: MerchantUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        ...StandardUserToJSONTyped(value, true),
        'stripeAccountIds': value['stripeAccountIds'],
        'latestMerchantAgreementId': value['latestMerchantAgreementId'],
    };
}

